// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Json$BwaxAdmin = require("../../../../bwax-js/ml/utils/json.bs.js");
var Plate$BwaxAdmin = require("../../../../bwax-js/ml/plate.bs.js");
var Lang_eval$BwaxAdmin = require("../../../../bwax-js/ml/lang/lang_eval.bs.js");
var Caml_chrome_debugger = require("bs-platform/lib/js/caml_chrome_debugger.js");
var Query_entry$BwaxAdmin = require("../../../../bwax-js/ml/query/query_entry.bs.js");
var Lang_mod_json$BwaxAdmin = require("../../../../bwax-js/ml/lang/mod/builtin/lang_mod_json.bs.js");
var Widget_common$BwaxAdmin = require("./widget_common.bs.js");
var Runtime_common$BwaxAdmin = require("../../../../bwax-js/ml/lang/mod/runtime_common.bs.js");

var module_name = "MiscUI";

var src = "\n\n-- 各种较为复杂但又不成体系的 UI Widgets\n\nmodule " + (String(module_name) + ";\n\nimport Element exposing (Rule, Element);\n\n-- 不再建议在使用 mdIcon, 应该改为使用 box icons\nmdIcon: List (Rule msg) -> String -> Element msg = external;\n\ntype BoxIconType = Regular | Solid | Logo;\n\nboxIcon: List (Rule msg) \n    -> ~{ rotate: Int -- Only 90, 180, 270 are supported\n        , flipHorizontal: Bool, flipVertical: Bool, pullLeft: Bool, pullRight: Bool\n        , animation: String, animationOnHover: String\n        , iconType: BoxIconType\n        } \n    -> String \n    -> Element msg = external; \n\n\n-- newsflash: List (Rule msg) -> Int -> List (Element msg) -> Element msg = external;\n\n-- 用于微信登录\nwechatLoginCode: \n      List (Rule msg)\n    -> ~{ size : Int, onCountDown: Int -> msg, onSuccess: msg! }\n    -> Element msg = external;\n\n--    rules\n--    -> welcome section \n--    -> [ ( navigation item,  section )] \n--    -> footer section \n--    -> ([ wrapped navigation item element ] -> navigation bar)\n--    -> config\n--  -> result element\nonePageLayout001: \n      List (Rule msg)\n    -> Element msg \n    -> List (Element msg, Element msg)\n    -> Element msg \n    -> (List (Element msg) -> Element msg)\n    -> ~{ onScrolledToSection: Int -> msg\n        }\n    -> Element msg\n  = external\n;\n\n\nswiper: \n      List (Rule msg)\n    -> ~{ activeIndex: Int, onActiveIndexChange: Int -> msg }\n    -> List ({ isActive: Bool, isPrev: Bool, isNext: Bool, isVisible: Bool } -> Element msg)\n    -> ~{ height: Int\n        , width: Int \n\n        , virtual: ~ { addSlidesAfter: Int, addSlidesBefore: Int }\n\n        , autoplay: ~ { delay: Int, disableOnInteraction: Int, pauseOnMouseEnter: Int, reverseDirection: Int, stopOnLastSlide: Int }\n\n        , enabled: Bool\n        , speed: Int \n        , threshold: Int\n\n        , allowSlideNext: Bool\n        , allowSlidePrev: Bool\n        , allowTouchMove: Bool\n        , autoHeight: Bool\n\n        , centerInsufficientSlides: Bool\n        , centeredSlides: Bool\n        , centeredSlidesBounds: Bool\n\n        , direction: String\n\n        , edgeSwipeDetection: Bool\n        , edgeSwipeThreshold: Int\n\n        , effect: String\n\n        , loop: Bool\n        , loopAdditionalSlides: Int\n        , loopFillGroupWithBlank: Bool\n        , loopPreventsSlide: Bool\n\n        , noSwiping: Bool\n        \n        , slidesOffsetAfter: Int\n        , slidesOffsetBefore: Int\n        , slidesPerColumn: Int\n        , slidesPerColumnFill: String\n        , slidesPerGroup: Int\n        , slidesPerGroupSkip: Int\n        , slidesPerView: Int\n        }\n    -> Element msg\n  = external\n;\n\n\nmodal:\n      List (Rule msg)       -- modal container\'s rules\n    -> ~{ open: Bool !, onBackgroundClick: msg , size: Size\n        , onClose: msg\n        , title: Element msg, footer: Element msg\n        , compact: Bool\n        } \n    -> Element msg          -- content\n    -> Element msg \n  = external\n;\n\n\n-- 用于群蜂社拆解\npagedDataList: \n    List (Rule msg)\n  -> QueryConfig a \n  -> ~{ isLazy : Bool, loading: Element msg \n      , pageSize: Int                         -- paginiation settings, 默认为 20\n      , header: Element msg\n      }\n  -> (# a -> Element msg)                     -- render\n  -> Element msg = external;\n\n\n-- typewriter effect:\ntype TypeWriterEffect msg = \n  | TypeString (List (Rule msg)) String  -- only suport text style related rules.\n  | PasteString (List (Rule msg)) String\n  | PauseFor Int            -- milliseconds\n  | DeleteAll Int           -- speed, which means delay between deleting each character, the lower the qfaster\n  | DeleteChars Int         -- Number of characters to delete\n  | ChangeDelay Int         -- change typing speed\n  | ChangeDeleteSpeed Int\n;\n\ntypeWriterEffect:\n    List (Rule msg)\n    -> ~{ delay: Int  -- typing speed, the lower the faster\n        , deleteSpeed: Int\n        , loop: Bool\n        }\n    ->  List (TypeWriterEffect msg)\n    ->  Element msg\n  = external; \n;\n\n\n\nautoPlayVideo: \n    List (Rule msg)\n  -> ~{ src: String!, alt: String }\n  -> Element msg = external;\n\n\n\n");

function pack_element(module_element) {
  return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
            module_name,
            module_element
          ]);
}

function fail(name) {
  throw [
        Lang_eval$BwaxAdmin.Eval_exn,
        module_name + ("." + (name + ": Invalid Arguments"))
      ];
}

var externals_vals_000 = /* tuple */[
  "mdIcon",
  Widget_common$BwaxAdmin.pack_element_func(2, (function (param) {
          if (param) {
            var match = param[0][0];
            if (typeof match === "number" || match.tag !== /* V_list */1) {
              return fail("newsflash");
            } else {
              var match$1 = param[1];
              if (match$1) {
                var match$2 = match$1[0][0];
                if (typeof match$2 === "number" || match$2.tag !== /* V_literal */5) {
                  return fail("newsflash");
                } else {
                  var match$3 = match$2[0];
                  if (typeof match$3 === "number" || !(match$3.tag === /* String */2 && !match$1[1])) {
                    return fail("newsflash");
                  } else {
                    var rules = Widget_common$BwaxAdmin.raw_to_rules(match[0]);
                    return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
                              module_name,
                              /* MD_Icon */Caml_chrome_debugger.variant("MD_Icon", 0, [
                                  rules,
                                  match$3[0]
                                ])
                            ]);
                  }
                }
              } else {
                return fail("newsflash");
              }
            }
          } else {
            return fail("newsflash");
          }
        }))
];

var externals_vals_001 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
    /* tuple */[
      "boxIcon",
      Widget_common$BwaxAdmin.pack_element_func(3, (function (param) {
              if (param) {
                var match = param[0][0];
                if (typeof match === "number" || match.tag !== /* V_list */1) {
                  return fail("boxIcon");
                } else {
                  var match$1 = param[1];
                  if (match$1) {
                    var match$2 = match$1[1];
                    if (match$2) {
                      var match$3 = match$2[0][0];
                      if (typeof match$3 === "number" || match$3.tag !== /* V_literal */5) {
                        return fail("boxIcon");
                      } else {
                        var match$4 = match$3[0];
                        if (typeof match$4 === "number" || !(match$4.tag === /* String */2 && !match$2[1])) {
                          return fail("boxIcon");
                        } else {
                          var config = match$1[0];
                          var rules = Widget_common$BwaxAdmin.raw_to_rules(match[0]);
                          var true_then = function (v, maybe_true) {
                            return Plate$BwaxAdmin.$$Option.and_then((function (b) {
                                          if (b) {
                                            return Caml_option.some(v);
                                          }
                                          
                                        }), maybe_true);
                          };
                          var style_classes = Plate$BwaxAdmin.List.clean(/* :: */Caml_chrome_debugger.simpleVariant("::", [
                                  Plate$BwaxAdmin.$$Option.map((function (n) {
                                          return "rotate-" + String(n);
                                        }), Lang_eval$BwaxAdmin.get_int("rotate", config)),
                                  /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                      true_then("flip-horizontal", Lang_eval$BwaxAdmin.get_bool("flipHorizontal", config)),
                                      /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                          true_then("flip-vertical", Lang_eval$BwaxAdmin.get_bool("flipVertical", config)),
                                          /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                              true_then("pull-left", Lang_eval$BwaxAdmin.get_bool("pullLeft", config)),
                                              /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                  true_then("pull-right", Lang_eval$BwaxAdmin.get_bool("pullRight", config)),
                                                  /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                      Lang_eval$BwaxAdmin.get_string("animation", config),
                                                      /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                          Plate$BwaxAdmin.$$Option.map((function (s) {
                                                                  return s + "-hover";
                                                                }), Lang_eval$BwaxAdmin.get_string("animationOnHover", config)),
                                                          /* [] */0
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ])
                                ]));
                          var iconType = Plate$BwaxAdmin.$$Option.and_then((function (param) {
                                  var match = param[0];
                                  if (typeof match === "number" || !(match.tag === /* V_tagged */6 && !match[1])) {
                                    return ;
                                  } else {
                                    return match[0];
                                  }
                                }), Lang_eval$BwaxAdmin.get_field("iconType", config));
                          return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
                                    module_name,
                                    /* Box_Icon */Caml_chrome_debugger.variant("Box_Icon", 1, [
                                        rules,
                                        style_classes,
                                        iconType,
                                        match$4[0]
                                      ])
                                  ]);
                        }
                      }
                    } else {
                      return fail("boxIcon");
                    }
                  } else {
                    return fail("boxIcon");
                  }
                }
              } else {
                return fail("boxIcon");
              }
            }))
    ],
    /* :: */Caml_chrome_debugger.simpleVariant("::", [
        /* tuple */[
          "newsflash",
          Widget_common$BwaxAdmin.pack_element_func(3, (function (param) {
                  if (param) {
                    var match = param[0][0];
                    if (typeof match === "number" || match.tag !== /* V_list */1) {
                      return fail("newsflash");
                    } else {
                      var match$1 = param[1];
                      if (match$1) {
                        var match$2 = match$1[0][0];
                        if (typeof match$2 === "number" || match$2.tag !== /* V_literal */5) {
                          return fail("newsflash");
                        } else {
                          var match$3 = match$2[0];
                          if (typeof match$3 === "number" || match$3.tag) {
                            return fail("newsflash");
                          } else {
                            var match$4 = match$1[1];
                            if (match$4) {
                              var match$5 = match$4[0][0];
                              if (typeof match$5 === "number" || !(match$5.tag === /* V_list */1 && !match$4[1])) {
                                return fail("newsflash");
                              } else {
                                var rules = Widget_common$BwaxAdmin.raw_to_rules(match[0]);
                                var elements = Widget_common$BwaxAdmin.collect_elements(match$5[0]);
                                return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
                                          module_name,
                                          /* UI_newsflash */Caml_chrome_debugger.variant("UI_newsflash", 2, [
                                              rules,
                                              match$3[0],
                                              elements
                                            ])
                                        ]);
                              }
                            } else {
                              return fail("newsflash");
                            }
                          }
                        }
                      } else {
                        return fail("newsflash");
                      }
                    }
                  } else {
                    return fail("newsflash");
                  }
                }))
        ],
        /* :: */Caml_chrome_debugger.simpleVariant("::", [
            /* tuple */[
              "wechatLoginCode",
              Widget_common$BwaxAdmin.pack_element_func(2, (function (param) {
                      if (param) {
                        var match = param[0][0];
                        if (typeof match === "number" || match.tag !== /* V_list */1) {
                          return fail("wechatLoginCode");
                        } else {
                          var match$1 = param[1];
                          if (match$1) {
                            var match$2 = match$1[0][0];
                            if (typeof match$2 === "number" || !(match$2.tag === /* V_record */2 && !match$1[1])) {
                              return fail("wechatLoginCode");
                            } else {
                              var config = match$2[0];
                              var rules = Widget_common$BwaxAdmin.raw_to_rules(match[0]);
                              var m_size = Plate$BwaxAdmin.$$Option.and_then(Lang_eval$BwaxAdmin.as_int, Plate$BwaxAdmin.List.assoc("size", config));
                              var match$3 = Plate$BwaxAdmin.List.assoc("onCountDown", config);
                              var m_onCountDown;
                              if (match$3 !== undefined) {
                                var tagger = match$3;
                                m_onCountDown = (function (counter) {
                                    return Lang_eval$BwaxAdmin.apply_value(undefined, tagger, Runtime_common$BwaxAdmin.pack_int(counter), Runtime_common$BwaxAdmin.nt);
                                  });
                              } else {
                                m_onCountDown = undefined;
                              }
                              var match$4 = Plate$BwaxAdmin.List.assoc("onSuccess", config);
                              var onSuccess = match$4 !== undefined ? match$4 : fail("wechatLoginCode");
                              return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
                                        module_name,
                                        /* UI_wechatLoginCode */Caml_chrome_debugger.variant("UI_wechatLoginCode", 3, [
                                            rules,
                                            m_size,
                                            m_onCountDown,
                                            onSuccess
                                          ])
                                      ]);
                            }
                          } else {
                            return fail("wechatLoginCode");
                          }
                        }
                      } else {
                        return fail("wechatLoginCode");
                      }
                    }))
            ],
            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                /* tuple */[
                  "onePageLayout001",
                  Widget_common$BwaxAdmin.pack_element_func(6, (function (param) {
                          if (param) {
                            var match = param[0][0];
                            if (typeof match === "number" || match.tag !== /* V_list */1) {
                              return fail("onePageLayout001");
                            } else {
                              var match$1 = param[1];
                              if (match$1) {
                                var match$2 = match$1[0][0];
                                if (typeof match$2 === "number" || match$2.tag !== /* V_raw */7) {
                                  return fail("onePageLayout001");
                                } else {
                                  var match$3 = match$1[1];
                                  if (match$3) {
                                    var match$4 = match$3[0][0];
                                    if (typeof match$4 === "number" || match$4.tag !== /* V_list */1) {
                                      return fail("onePageLayout001");
                                    } else {
                                      var match$5 = match$3[1];
                                      if (match$5) {
                                        var match$6 = match$5[0][0];
                                        if (typeof match$6 === "number" || match$6.tag !== /* V_raw */7) {
                                          return fail("onePageLayout001");
                                        } else {
                                          var match$7 = match$5[1];
                                          if (match$7) {
                                            var match$8 = match$7[1];
                                            if (match$8) {
                                              var match$9 = match$8[0][0];
                                              if (typeof match$9 === "number" || !(match$9.tag === /* V_record */2 && !match$8[1])) {
                                                return fail("onePageLayout001");
                                              } else {
                                                var buildNavBar = match$7[0];
                                                var rules = Widget_common$BwaxAdmin.raw_to_rules(match[0]);
                                                var sections = Plate$BwaxAdmin.List.keep_map((function (param) {
                                                        var match = param[0];
                                                        if (typeof match === "number" || match.tag) {
                                                          return ;
                                                        } else {
                                                          var match$1 = match[0];
                                                          if (match$1) {
                                                            var match$2 = match$1[0][0];
                                                            if (typeof match$2 === "number" || match$2.tag !== /* V_raw */7) {
                                                              return ;
                                                            } else {
                                                              var match$3 = match$1[1];
                                                              if (match$3) {
                                                                var match$4 = match$3[0][0];
                                                                if (typeof match$4 === "number" || !(match$4.tag === /* V_raw */7 && !match$3[1])) {
                                                                  return ;
                                                                } else {
                                                                  return /* tuple */[
                                                                          match$2[0],
                                                                          match$4[0]
                                                                        ];
                                                                }
                                                              } else {
                                                                return ;
                                                              }
                                                            }
                                                          } else {
                                                            return ;
                                                          }
                                                        }
                                                      }), match$4[0]);
                                                var build_nav_bar = function (elements) {
                                                  var elements_value = Runtime_common$BwaxAdmin.pack_list(Plate$BwaxAdmin.List.map(Runtime_common$BwaxAdmin.pack_raw, Plate$BwaxAdmin.List.map((function (prim) {
                                                                  return prim;
                                                                }), elements)));
                                                  var match = Lang_eval$BwaxAdmin.apply_value(undefined, buildNavBar, elements_value, Runtime_common$BwaxAdmin.nt);
                                                  var match$1 = match[0];
                                                  if (typeof match$1 === "number" || match$1.tag !== /* V_raw */7) {
                                                    return fail("onePageLayout001(build_nav_bar)");
                                                  } else {
                                                    return match$1[0];
                                                  }
                                                };
                                                var on_scrolled_to_section = Plate$BwaxAdmin.$$Option.map((function (onScrolledToSection) {
                                                        return (function (index) {
                                                            var v_000 = /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* Int */Caml_chrome_debugger.variant("Int", 0, [index])]);
                                                            var v = /* tuple */[
                                                              v_000,
                                                              Runtime_common$BwaxAdmin.nt
                                                            ];
                                                            return Lang_eval$BwaxAdmin.apply_value(undefined, onScrolledToSection, v, Runtime_common$BwaxAdmin.nt);
                                                          });
                                                      }), Plate$BwaxAdmin.List.assoc("onScrolledToSection", match$9[0]));
                                                return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
                                                          module_name,
                                                          /* UI_onePageLayout001 */Caml_chrome_debugger.variant("UI_onePageLayout001", 4, [
                                                              rules,
                                                              match$2[0],
                                                              sections,
                                                              match$6[0],
                                                              build_nav_bar,
                                                              on_scrolled_to_section
                                                            ])
                                                        ]);
                                              }
                                            } else {
                                              return fail("onePageLayout001");
                                            }
                                          } else {
                                            return fail("onePageLayout001");
                                          }
                                        }
                                      } else {
                                        return fail("onePageLayout001");
                                      }
                                    }
                                  } else {
                                    return fail("onePageLayout001");
                                  }
                                }
                              } else {
                                return fail("onePageLayout001");
                              }
                            }
                          } else {
                            return fail("onePageLayout001");
                          }
                        }))
                ],
                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                    /* tuple */[
                      "swiper",
                      Widget_common$BwaxAdmin.pack_element_func(4, (function (args) {
                              if (args) {
                                var match = args[0][0];
                                if (typeof match !== "number" && match.tag === /* V_list */1) {
                                  var match$1 = args[1];
                                  if (match$1) {
                                    var match$2 = match$1[0][0];
                                    if (typeof match$2 !== "number" && match$2.tag === /* V_record */2) {
                                      var match$3 = match$1[1];
                                      if (match$3) {
                                        var match$4 = match$3[0][0];
                                        if (typeof match$4 !== "number" && match$4.tag === /* V_list */1) {
                                          var match$5 = match$3[1];
                                          if (match$5 && !match$5[1]) {
                                            var config = match$2[0];
                                            var rules = Widget_common$BwaxAdmin.raw_to_rules(match[0]);
                                            var onActiveIndexChange = Plate$BwaxAdmin.$$Option.map((function (tagger, index) {
                                                    return Lang_eval$BwaxAdmin.apply_value(undefined, tagger, Runtime_common$BwaxAdmin.pack_int(index), Runtime_common$BwaxAdmin.nt);
                                                  }), Plate$BwaxAdmin.List.assoc("onActiveIndexChange", config));
                                            var activeIndex = Plate$BwaxAdmin.$$Option.and_then(Lang_eval$BwaxAdmin.as_int, Plate$BwaxAdmin.List.assoc("activeIndex", config));
                                            var slide_builders = Plate$BwaxAdmin.List.map((function (builder, json) {
                                                    var match = Runtime_common$BwaxAdmin.json_to_value(json);
                                                    if (match !== undefined) {
                                                      var match$1 = Lang_eval$BwaxAdmin.apply_value(undefined, builder, match, Runtime_common$BwaxAdmin.nt);
                                                      var match$2 = match$1[0];
                                                      if (typeof match$2 === "number" || match$2.tag !== /* V_raw */7) {
                                                        return fail("swiper-<slide-builder>");
                                                      } else {
                                                        return match$2[0];
                                                      }
                                                    } else {
                                                      return fail("swiper-<slide>");
                                                    }
                                                  }), match$4[0]);
                                            var options = Plate$BwaxAdmin.$$Option.with_default(Json$BwaxAdmin.json_object(/* [] */0), Lang_mod_json$BwaxAdmin.any_value_to_plain_json(match$5[0]));
                                            return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
                                                      module_name,
                                                      /* UI_swiper */Caml_chrome_debugger.variant("UI_swiper", 5, [
                                                          rules,
                                                          /* record */Caml_chrome_debugger.record([
                                                              "activeIndex",
                                                              "onActiveIndexChange"
                                                            ], [
                                                              activeIndex,
                                                              onActiveIndexChange
                                                            ]),
                                                          slide_builders,
                                                          options
                                                        ])
                                                    ]);
                                          }
                                          
                                        }
                                        
                                      }
                                      
                                    }
                                    
                                  }
                                  
                                }
                                
                              }
                              console.log("swiper args", args);
                              return fail("swiper");
                            }))
                    ],
                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                        /* tuple */[
                          "modal",
                          Widget_common$BwaxAdmin.pack_element_func(3, (function (param) {
                                  if (param) {
                                    var match = param[0][0];
                                    if (typeof match === "number" || match.tag !== /* V_list */1) {
                                      return Runtime_common$BwaxAdmin.invalid_args("modal ");
                                    } else {
                                      var match$1 = param[1];
                                      if (match$1) {
                                        var match$2 = match$1[0][0];
                                        if (typeof match$2 === "number" || match$2.tag !== /* V_record */2) {
                                          return Runtime_common$BwaxAdmin.invalid_args("modal ");
                                        } else {
                                          var match$3 = match$1[1];
                                          if (match$3) {
                                            var match$4 = match$3[0][0];
                                            if (typeof match$4 === "number" || !(match$4.tag === /* V_raw */7 && !match$3[1])) {
                                              return Runtime_common$BwaxAdmin.invalid_args("modal ");
                                            } else {
                                              var config_v = match$2[0];
                                              var rules = Widget_common$BwaxAdmin.raw_to_rules(match[0]);
                                              var is_open = Plate$BwaxAdmin.$$Option.with_default(false, Plate$BwaxAdmin.$$Option.and_then(Lang_eval$BwaxAdmin.as_bool, Plate$BwaxAdmin.List.assoc("open", config_v))) || Plate$BwaxAdmin.$$Option.with_default(false, Plate$BwaxAdmin.$$Option.and_then(Lang_eval$BwaxAdmin.as_bool, Plate$BwaxAdmin.List.assoc("visible", config_v)));
                                              var on_background_click = Plate$BwaxAdmin.List.assoc("onBackgroundClick", config_v);
                                              var on_close = Plate$BwaxAdmin.List.assoc("onClose", config_v);
                                              var size = Plate$BwaxAdmin.$$Option.and_then((function (param) {
                                                      var match = param[0];
                                                      if (typeof match === "number" || match.tag !== /* V_tagged */6) {
                                                        return ;
                                                      } else {
                                                        return match[0];
                                                      }
                                                    }), Plate$BwaxAdmin.List.assoc("size", config_v));
                                              var title = Plate$BwaxAdmin.$$Option.and_then(Widget_common$BwaxAdmin.as_element, Plate$BwaxAdmin.List.assoc("title", config_v));
                                              var footer = Plate$BwaxAdmin.$$Option.and_then(Widget_common$BwaxAdmin.as_element, Plate$BwaxAdmin.List.assoc("footer", config_v));
                                              var compact = Plate$BwaxAdmin.$$Option.with_default(false, Plate$BwaxAdmin.$$Option.and_then(Lang_eval$BwaxAdmin.as_bool, Plate$BwaxAdmin.List.assoc("compact", config_v)));
                                              var modal_config = /* record */Caml_chrome_debugger.record([
                                                  "is_open",
                                                  "on_background_click",
                                                  "size",
                                                  "on_close",
                                                  "title",
                                                  "footer",
                                                  "compact"
                                                ], [
                                                  is_open,
                                                  on_background_click,
                                                  size,
                                                  on_close,
                                                  title,
                                                  footer,
                                                  compact
                                                ]);
                                              return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
                                                        module_name,
                                                        /* UI_modal */Caml_chrome_debugger.variant("UI_modal", 6, [
                                                            rules,
                                                            modal_config,
                                                            match$4[0]
                                                          ])
                                                      ]);
                                            }
                                          } else {
                                            return Runtime_common$BwaxAdmin.invalid_args("modal ");
                                          }
                                        }
                                      } else {
                                        return Runtime_common$BwaxAdmin.invalid_args("modal ");
                                      }
                                    }
                                  } else {
                                    return Runtime_common$BwaxAdmin.invalid_args("modal ");
                                  }
                                }))
                        ],
                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                            /* tuple */[
                              "pagedDataList",
                              Widget_common$BwaxAdmin.pack_element_func(4, (function (param) {
                                      if (param) {
                                        var match = param[0][0];
                                        if (typeof match === "number" || match.tag !== /* V_list */1) {
                                          return Runtime_common$BwaxAdmin.invalid_args("pagedDataList");
                                        } else {
                                          var match$1 = param[1];
                                          if (match$1) {
                                            var match$2 = match$1[1];
                                            if (match$2) {
                                              var match$3 = match$2[0][0];
                                              if (typeof match$3 === "number" || match$3.tag !== /* V_record */2) {
                                                return Runtime_common$BwaxAdmin.invalid_args("pagedDataList");
                                              } else {
                                                var match$4 = match$2[1];
                                                if (match$4 && !match$4[1]) {
                                                  var config_v = match$3[0];
                                                  var rules = Widget_common$BwaxAdmin.raw_to_rules(match[0]);
                                                  var query_config = Query_entry$BwaxAdmin.make_query_config(match$1[0]);
                                                  var lazy_v = Plate$BwaxAdmin.$$Option.with_default(false, Plate$BwaxAdmin.$$Option.and_then(Lang_eval$BwaxAdmin.as_bool, Plate$BwaxAdmin.List.assoc("isLazy", config_v)));
                                                  var loading = Plate$BwaxAdmin.$$Option.and_then(Widget_common$BwaxAdmin.as_element, Plate$BwaxAdmin.List.assoc("loading", config_v));
                                                  var pageSize = Plate$BwaxAdmin.$$Option.with_default(20, Plate$BwaxAdmin.$$Option.and_then(Lang_eval$BwaxAdmin.as_int, Plate$BwaxAdmin.List.assoc("pageSize", config_v)));
                                                  var header = Plate$BwaxAdmin.$$Option.and_then(Widget_common$BwaxAdmin.as_element, Plate$BwaxAdmin.List.assoc("header", config_v));
                                                  return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
                                                            module_name,
                                                            /* Paged_data_list */Caml_chrome_debugger.variant("Paged_data_list", 7, [
                                                                rules,
                                                                query_config,
                                                                /* tuple */[
                                                                  lazy_v,
                                                                  loading,
                                                                  pageSize,
                                                                  header
                                                                ],
                                                                match$4[0]
                                                              ])
                                                          ]);
                                                } else {
                                                  return Runtime_common$BwaxAdmin.invalid_args("pagedDataList");
                                                }
                                              }
                                            } else {
                                              return Runtime_common$BwaxAdmin.invalid_args("pagedDataList");
                                            }
                                          } else {
                                            return Runtime_common$BwaxAdmin.invalid_args("pagedDataList");
                                          }
                                        }
                                      } else {
                                        return Runtime_common$BwaxAdmin.invalid_args("pagedDataList");
                                      }
                                    }))
                            ],
                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                /* tuple */[
                                  "typeWriterEffect",
                                  Widget_common$BwaxAdmin.pack_element_func(3, (function (param) {
                                          if (param) {
                                            var match = param[0][0];
                                            if (typeof match === "number" || match.tag !== /* V_list */1) {
                                              return Runtime_common$BwaxAdmin.invalid_args("typeWriterEffect");
                                            } else {
                                              var match$1 = param[1];
                                              if (match$1) {
                                                var match$2 = match$1[1];
                                                if (match$2) {
                                                  var match$3 = match$2[0][0];
                                                  if (typeof match$3 === "number" || !(match$3.tag === /* V_list */1 && !match$2[1])) {
                                                    return Runtime_common$BwaxAdmin.invalid_args("typeWriterEffect");
                                                  } else {
                                                    var config = Plate$BwaxAdmin.$$Option.with_default(Json$BwaxAdmin.json_object(/* [] */0), Lang_mod_json$BwaxAdmin.any_value_to_plain_json(match$1[0]));
                                                    var rules = Widget_common$BwaxAdmin.raw_to_rules(match[0]);
                                                    return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
                                                              module_name,
                                                              /* Type_writer_effect */Caml_chrome_debugger.variant("Type_writer_effect", 8, [
                                                                  rules,
                                                                  config,
                                                                  match$3[0]
                                                                ])
                                                            ]);
                                                  }
                                                } else {
                                                  return Runtime_common$BwaxAdmin.invalid_args("typeWriterEffect");
                                                }
                                              } else {
                                                return Runtime_common$BwaxAdmin.invalid_args("typeWriterEffect");
                                              }
                                            }
                                          } else {
                                            return Runtime_common$BwaxAdmin.invalid_args("typeWriterEffect");
                                          }
                                        }))
                                ],
                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                    /* tuple */[
                                      "autoPlayVideo",
                                      Widget_common$BwaxAdmin.pack_element_func(2, (function (param) {
                                              if (param) {
                                                var match = param[0][0];
                                                if (typeof match === "number" || match.tag !== /* V_list */1) {
                                                  return Runtime_common$BwaxAdmin.invalid_args("autoPlayVideo");
                                                } else {
                                                  var match$1 = param[1];
                                                  if (match$1) {
                                                    var match$2 = match$1[0][0];
                                                    if (typeof match$2 === "number" || !(match$2.tag === /* V_record */2 && !match$1[1])) {
                                                      return Runtime_common$BwaxAdmin.invalid_args("autoPlayVideo");
                                                    } else {
                                                      var config_v = match$2[0];
                                                      var rules = Widget_common$BwaxAdmin.raw_to_rules(match[0]);
                                                      var src = Plate$BwaxAdmin.$$Option.and_then(Lang_eval$BwaxAdmin.as_string, Plate$BwaxAdmin.List.assoc("src", config_v));
                                                      var alt = Plate$BwaxAdmin.$$Option.and_then(Lang_eval$BwaxAdmin.as_string, Plate$BwaxAdmin.List.assoc("alt", config_v));
                                                      if (src !== undefined) {
                                                        return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
                                                                  module_name,
                                                                  /* Auto_paly_video */Caml_chrome_debugger.variant("Auto_paly_video", 9, [
                                                                      rules,
                                                                      src,
                                                                      alt
                                                                    ])
                                                                ]);
                                                      } else {
                                                        return Runtime_common$BwaxAdmin.invalid_args("autoPlayVideo");
                                                      }
                                                    }
                                                  } else {
                                                    return Runtime_common$BwaxAdmin.invalid_args("autoPlayVideo");
                                                  }
                                                }
                                              } else {
                                                return Runtime_common$BwaxAdmin.invalid_args("autoPlayVideo");
                                              }
                                            }))
                                    ],
                                    /* [] */0
                                  ])
                              ])
                          ])
                      ])
                  ])
              ])
          ])
      ])
  ]);

var externals_vals = /* :: */Caml_chrome_debugger.simpleVariant("::", [
    externals_vals_000,
    externals_vals_001
  ]);

var externals_000 = module_name;

var externals = /* tuple */[
  externals_000,
  externals_vals
];

var command_handlers = /* [] */0;

exports.module_name = module_name;
exports.src = src;
exports.pack_element = pack_element;
exports.fail = fail;
exports.externals_vals = externals_vals;
exports.command_handlers = command_handlers;
exports.externals = externals;
/* src Not a pure module */
